"use client";

import {
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenu,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Ellipsis } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import { env } from "@/env";
import ReportModal from "./report-modal";
import { useAuth } from "@/context/AuthContext";

type MoreProps = {
  slug: string;
};

export default function More({ slug }: MoreProps) {
  const { user, accessToken } = useAuth();
  const { toast } = useToast();

  const handleFavorite = async () => {
    if (!user) {
      return toast({
        title: "Authentication required",
        description: "Please sign in to favorite",
        variant: "destructive",
      });
    }

    try {
      const response = await fetch(
        `${env.NEXT_PUBLIC_API_URL}/post/${slug}/favorite`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      ).then((res) => res.json());

      if (response.message !== "OK") {
        return toast({
          title: "Error",
          description: response.message,
          variant: "destructive",
        });
      }

      toast({
        title: "Success",
        description: "Script favorited successfully",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to favorite script",
        variant: "destructive",
      });
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" aria-label="More options">
          <Ellipsis size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={handleFavorite}>Favorite</DropdownMenuItem>
        <ReportModal slug={slug} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
